/*
 * Created on Mon Jun 05 2023
 *
 * Copyright (c) Cynnox, Inc - All Rights Reserved 2023 Jagan
 *
 *Unauthorized copying of this file, via any medium is strictly prohibited
 *Proprietary and confidential Written by Jagan <jagancpj246@gmail.com>, September 2020.
 */

export const PAGE_SCREEN = {
  LOGIN_PAGE: 'login_page',
  CONFIRM_PASS: 'confirm_pass',
  SUCCESS_MSG: 'success_msg',
};
